import { useContext, useEffect } from "react";
import { CadviewerContext } from "../../../context/Cadviewer.Context";
import { AIChat, useAIChatStore } from "../stores/aiChatStore";
import { AIActionResponse, ChatMessage } from "../types/aiChatClient";

export interface UseAIChatReturnType {
  messages: ChatMessage[];
  isLoading: boolean;
  isSearching: boolean;
  error: string | null;
  sendMessage: (prompt: string) => Promise<void>;
  currentAction: AIActionResponse | null;
  clearError: () => void;
  clearHistoryMessagesToSend: () => void;
  internalCADViewerAICallback: (chatMessage: ChatMessage) => void;
  currentHighlight: string | null;
  clearCurrentHighlight: () => void;
}

export function useAIChat(): UseAIChatReturnType {
  const { plansInfo, distanceData, selectedPlan, selectedPlanDetail } = useContext(CadviewerContext);
  //console.log({ plansInfo, distanceData });
  const spacesNames =
    plansInfo?.spaces.map((space) => ({
      name: space.spaceHeader,
      dbas: [], // space.detailTabs.map((tab) => tab.detail.DBA),
    })) || [];

  // Utiliser directement les propriétés du store avec destructuring
  const messages = useAIChatStore((state: AIChat) => state.messages);
  const isLoading = useAIChatStore((state: AIChat) => state.isLoading);
  const isSearching = useAIChatStore((state: AIChat) => state.isSearching);
  const error = useAIChatStore((state: AIChat) => state.error);
  const currentAction = useAIChatStore((state: AIChat) => state.currentAction);
  const currentHighlight = useAIChatStore(
    (state: AIChat) => state.currentHighlight
  );
  const clearCurrentHighlight = useAIChatStore(
    (state: AIChat) => state.clearCurrentHighlight
  );
  const sendMessage = useAIChatStore((state: AIChat) => state.sendMessage);
  const mockSendMessage = async (
    prompt: string,
    useGlobalMode: boolean = false,
    selectedSpaces?: string[]
  ) => {
    await sendMessage(
      prompt,
      spacesNames,
      selectedPlan,
      selectedPlanDetail,
      useGlobalMode,
      selectedSpaces
    );
  };
  const clearError = useAIChatStore((state: AIChat) => state.clearError);
  const clearHistoryMessagesToSend = useAIChatStore(
    (state: AIChat) => state.clearHistoryMessagesToSend
  );
  const internalCADViewerAICallback = useAIChatStore(
    (state: AIChat) => state.internalCADViewerAICallback
  );
  const setPlansInfoAndDistanceData = useAIChatStore(
    (state: AIChat) => state.setPlansInfoAndDistanceData
  );

  // Synchroniser les données du context avec le store
  useEffect(() => {
    setPlansInfoAndDistanceData(plansInfo, distanceData);
  }, [plansInfo, distanceData, setPlansInfoAndDistanceData]);

  return {
    messages,
    isLoading,
    isSearching,
    error,
    sendMessage: mockSendMessage,
    currentAction,
    clearError,
    clearHistoryMessagesToSend,
    internalCADViewerAICallback,
    currentHighlight,
    clearCurrentHighlight,
  };
}
